import { FunctionComponent } from "react";
import { Container } from "../../../../components/formulario/styled";
import { HeaderMensagem } from "./header";
import TabelaMensagens from "./tabela";



interface ContainerMensagemProps {

}

const ContainerMensagem: FunctionComponent<ContainerMensagemProps> = () => {
  return ( <>
    <Container>
      <HeaderMensagem/>
      <TabelaMensagens/>
    </Container>
  </> );
}

export default ContainerMensagem;
